var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Col, Divider, Form, Icon, Row, Spin } from "antd";
import moment from "moment";
import React from "react";
import MediaQuery from "react-responsive";
import { DataUtils } from "../../utilities";
import LeftView from "./left-view";
import RightView from "./right-view";
var CreateSiteAlert = /** @class */ (function (_super) {
    __extends(CreateSiteAlert, _super);
    function CreateSiteAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            isPreview: false,
            onFormUpdated: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var onFormUpdate = _this.props.onFormUpdate;
            var isFieldsTouched = _this.props.form.isFieldsTouched;
            var onFormUpdated = _this.state.onFormUpdated;
            var oldOnFormUpdated = prevState.onFormUpdated;
            if (onFormUpdate && isFieldsTouched() && !onFormUpdated && !oldOnFormUpdated) {
                _this.setState({
                    onFormUpdated: true
                }, function () {
                    onFormUpdate();
                });
            }
        };
        _this.componentDidMount = function () {
            var _a = _this.props, authentication = _a.authentication, siteAlert = _a.siteAlert;
            DataUtils.systemConfig(authentication).get().then(function (onload) {
                _this.setState({ onload: onload });
            });
            if (siteAlert === null || siteAlert === void 0 ? void 0 : siteAlert.id) {
                DataUtils.siteAlerts(authentication).getOne(siteAlert.id).then(function (siteAlert) {
                    _this.setState({ siteAlert: siteAlert, isPreview: false });
                });
            }
        };
        _this.onSubmit = function (e, isPublish) {
            if (isPublish === void 0) { isPublish = true; }
            var validateFieldsAndScroll = _this.props.form.validateFieldsAndScroll;
            var _a = _this.props, authentication = _a.authentication, onCreate = _a.onCreate, onUpdate = _a.onUpdate;
            var _b = _this.state, isPreview = _b.isPreview, siteAlert = _b.siteAlert, onload = _b.onload;
            e.preventDefault();
            e.stopPropagation();
            validateFieldsAndScroll(function (err, values) {
                console.debug('Received values of serviceRequestForm: ', values, err);
                if (!err) {
                    if (isPreview || siteAlert) {
                        _this.setState({
                            isLoading: true
                        });
                        var newSiteAlert_1 = __assign({}, values);
                        newSiteAlert_1.isPublish = isPublish;
                        newSiteAlert_1.startTime = moment(newSiteAlert_1.startTime).valueOf();
                        if (newSiteAlert_1.tentativeETA) {
                            newSiteAlert_1.tentativeETA = moment(newSiteAlert_1.tentativeETA).valueOf();
                        }
                        newSiteAlert_1.issues = newSiteAlert_1.issues.map(function (issueId) { return ({ id: issueId }); });
                        newSiteAlert_1.status = onload === null || onload === void 0 ? void 0 : onload.siteAlert.status.find(function (status) { return status.id === newSiteAlert_1.status.id; });
                        var requests_1 = [];
                        if (!siteAlert) {
                            newSiteAlert_1.siteId.forEach(function (site) {
                                var createSiteAlert = __assign({}, newSiteAlert_1);
                                var foundSite = createSiteAlert.sites.find(function (item) { return item.id === site; });
                                createSiteAlert.site = {
                                    id: foundSite.id,
                                    name: foundSite.name,
                                    locales: foundSite.locales.filter(function (locale) { return createSiteAlert["locale_".concat(foundSite.id)].includes(locale.value); })
                                };
                                delete createSiteAlert.sites;
                                delete createSiteAlert.siteId;
                                createSiteAlert.impactedBrands = [];
                                var containers = createSiteAlert["to_".concat(foundSite.id, "_container")];
                                createSiteAlert["to_".concat(foundSite.id)].forEach(function (brandId) {
                                    var foundBrand = foundSite.brands.find(function (brand) { return brand.id === brandId; });
                                    createSiteAlert.impactedBrands.push({
                                        id: foundBrand.id,
                                        name: foundBrand.name,
                                        containers: foundBrand.containers.filter(function (item) { return containers.includes(item.name); })
                                    });
                                });
                                delete createSiteAlert["to_".concat(foundSite.id)];
                                delete createSiteAlert["to_".concat(foundSite.id, "_container")];
                                createSiteAlert.title = createSiteAlert["title_".concat(foundSite.id)];
                                delete createSiteAlert["title_".concat(foundSite.id)];
                                createSiteAlert.description = createSiteAlert["description_".concat(foundSite.id)];
                                delete createSiteAlert["description_".concat(foundSite.id)];
                                requests_1.push(DataUtils.siteAlerts(authentication).createOne(createSiteAlert).catch(function (e) { return e; }));
                            });
                            Promise.all(requests_1).then(function (responses) {
                                var success = responses.filter(function (response) { return !(response instanceof Error); });
                                var errors = responses.filter(function (response) { return (response instanceof Error); });
                                errors.forEach(function (error) {
                                    NotificationUtils.warning("Unable to create site alert", error.response.data.message);
                                });
                                if (success) {
                                    onCreate && onCreate(success);
                                }
                            }).finally(function () { return _this.setState({ isLoading: false }); });
                        }
                        else {
                            DataUtils.siteAlerts(authentication).updateOne(siteAlert.id || "", newSiteAlert_1).then(function (siteAlert) {
                                onUpdate && onUpdate(siteAlert);
                            }).finally(function () {
                                _this.setState({
                                    isLoading: false,
                                    onFormUpdated: false
                                });
                            });
                        }
                    }
                    else {
                        _this.setState({ isPreview: true });
                    }
                    ;
                }
            });
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, isPreview = _a.isPreview, siteAlert = _a.siteAlert, isLoading = _a.isLoading;
            var authentication = _this.props.authentication;
            return (onload ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    return React.createElement(Form, { colon: false, layout: "horizontal", className: "bold-label", onSubmit: _this.onSubmit },
                        React.createElement(Row, { type: "flex", style: { width: '100%' } },
                            React.createElement(Col, { xxl: 7, xl: 7, lg: 7, md: 24, sm: 24, xs: 24, order: matches ? 1 : 3, className: matches ? "padding-right-lg" : "" },
                                React.createElement(LeftView, { siteAlert: siteAlert, onload: onload, form: _this.props.form, authentication: authentication, isPreview: isPreview })),
                            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 0, xl: 0, xxl: 0, order: 2 },
                                React.createElement(Divider, null)),
                            React.createElement(Col, { xxl: 17, xl: 17, lg: 17, md: 24, sm: 24, xs: 24, order: matches ? 3 : 1, className: matches ? "padding-left-lg border-left" : "" },
                                React.createElement(RightView, { isLoading: isLoading, siteAlert: siteAlert, onload: onload, form: _this.props.form, authentication: authentication, isPreview: isPreview, toggleIsPreview: function () { return _this.setState({ isPreview: !isPreview }); }, onSubmit: function (e, isPublish) { return _this.onSubmit(e, isPublish); } }))));
                }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return CreateSiteAlert;
}(React.Component));
export default Form.create({ name: 'create-siteAlert' })(CreateSiteAlert);
//# sourceMappingURL=index.js.map